<ion-content scroll-y="false">
  <ion-header class="ach-form-retrieval" data-cy="ach-form-retrieval">
    <ion-grid>
      <ion-row class="header__title-row" [ngClass]="platformService.isWindows">
        <ion-col size="12">
          <div class="title-container">
            <h1 class="page-title-oswald" data-cy="title-text">
              {{ 'i18n.pageTitles.achFormRetrieval' | translate }}
            </h1>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-header>

  <div class="content-container">
    <ng-container *ngIf="isAR$ | async; else noAccess">
      <ion-grid>
        <ion-row class="form-row">
          <ion-col size="8">
            <ion-item>
              <ion-input
                type="text"
                [formControl]="auditIdControl"
                placeholder="Autopay Enrollment Audit ID"
                data-cy="audit-id-input"
              >
              </ion-input>
            </ion-item>
          </ion-col>
          <ion-col size="4" class="ion-align-self-end">
            <ion-button
              expand="block"
              data-cy="retrieve-form-button"
              (click)="getGeneratedACHFormID(auditIdControl.value)"
              [disabled]="!auditIdControl.value?.trim()"
            >
              Retrieve Form
            </ion-button>
          </ion-col>
        </ion-row>

        <ion-row *ngIf="achAuditID" class="form-row">
          <ion-col size="12">
            <ion-item>
              <ion-input
                type="text"
                [value]="achAuditID"
                readonly
                placeholder="ACH Audit ID"
                data-cy="ach-audit-id-display"
              >
              </ion-input>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-container>

    <ng-template #noAccess>
      <ion-grid class="error-container">
        <ion-row class="ion-justify-content-center ion-align-items-center">
          <ion-col size="12" class="ion-text-center">
            <ion-text color="danger">
              <h2>User Permission Error</h2>
              <p>
                You do not have permission to access the Autopay Setup Form.
              </p>
            </ion-text>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ng-template>
  </div>
</ion-content>
<app-footer></app-footer>
